// Bundled slot reference illustrations — thumbnails of the exemplar products
// Daniel picked (2026-08-05), mirrored where needed so three-quarter /
// standing-angle face the viewer's RIGHT per the shipped Phase 3 standard.
// Missing entries (standing-back, charms/pendants, earrings) render text-only
// tiles until art is decided.
import ringsFlat from '../../images/photo-slots/rings-flat.png'
import ringsThreeQuarter from '../../images/photo-slots/rings-three-quarter.png'
import ringsStandingFront from '../../images/photo-slots/rings-standing-front.png'
import ringsStandingAngle from '../../images/photo-slots/rings-standing-angle.png'
import bandsFlat from '../../images/photo-slots/bands-flat.png'
import bandsThreeQuarter from '../../images/photo-slots/bands-three-quarter.png'
import bandsStandingFront from '../../images/photo-slots/bands-standing-front.png'
import bandsStandingAngle from '../../images/photo-slots/bands-standing-angle.png'
import chainsCloseUp from '../../images/photo-slots/chains-close-up.png'
import chainsFull from '../../images/photo-slots/chains-full.png'
// Cowboy-boot charm shots are bundled MIRRORED: the piece was shot as an
// exception facing left; the pendant convention faces right (Daniel, 2026-08-05)
import charmsFront from '../../images/photo-slots/charms-front.png'
import charmsAngle from '../../images/photo-slots/charms-angle.png'
import charmsAngle3 from '../../images/photo-slots/charms-angle3.png'
import charmsAngle4 from '../../images/photo-slots/charms-angle4.png'
import charmsRuler from '../../images/photo-slots/charms-ruler.png'
import earringsPair from '../../images/photo-slots/earrings-pair.png'
// Bracelet-family art (2026-08-06): ball bracelet = Daniel's polished
// top-down; bangle flat = Daniel's raw run through the Phase 3 edit pipeline;
// bangle side = Gemini-invented clasp view (Daniel picked v3a) — illustrative
// example only, the clasp detail is partly the model's invention.
import braceletsTopDown from '../../images/photo-slots/bracelets-top-down.png'
import banglesFlat from '../../images/photo-slots/bangles-flat.png'
import banglesSide from '../../images/photo-slots/bangles-side.png'

const GROUPS = {
    'Rings': 'rings',
    "Men's Rings": 'rings',
    'Engagement Rings': 'rings',
    'Baby Rings': 'rings',
    'Wedding Bands': 'bands',
    'Chains': 'chains',
    'Anklets': 'bracelets',
    'Choker': 'chains',
    'Necklaces': 'chains',
    'Charm Necklace Set': 'chains',
    'Bracelets': 'bracelets',
    "Men's Bracelets": 'bracelets',
    'Baby Bracelets': 'bracelets',
    'Bangle Bracelets': 'bangles',
    'Charms': 'charms',
    'Pendants': 'charms',
    'Earrings': 'earrings',
};

const ART = {
    'rings-flat': ringsFlat,
    'rings-three-quarter': ringsThreeQuarter,
    'rings-standing-front': ringsStandingFront,
    'rings-standing-angle': ringsStandingAngle,
    'bands-flat': bandsFlat,
    'bands-three-quarter': bandsThreeQuarter,
    'bands-standing-front': bandsStandingFront,
    'bands-standing-angle': bandsStandingAngle,
    // standing-back reuses the standing-front photo — the picked exemplars look
    // the same from the back (Daniel, 2026-08-05); a note explains it (see NOTES)
    'rings-standing-back': ringsStandingFront,
    'bands-standing-back': bandsStandingFront,
    'chains-close-up': chainsCloseUp,
    'chains-full': chainsFull,
    'charms-front': charmsFront,
    'charms-angle': charmsAngle,
    'charms-angle3': charmsAngle3,
    'charms-angle4': charmsAngle4,
    'charms-ruler': charmsRuler,
    'earrings-pair': earringsPair,
    'bracelets-top-down': braceletsTopDown,
    'bangles-flat': banglesFlat,
    'bangles-side': banglesSide,
};

// slot key -> i18n key under photoUpload.notes.*
const NOTE_KEYS = {
    'standing-back': 'photoUpload.notes.standingBack',
};

export default function getSlotArt(category, slotKey) {
    const group = GROUPS[category];
    if (!group) return null;
    return ART[`${group}-${slotKey}`] ?? null;
}

// Module-level helper (not a component/hook), so `t` is passed in — same
// treatment as InventoryReport's `scopeText`.
export function getSlotNote(t, category, slotKey) {
    if (!getSlotArt(category, slotKey)) return null;
    const key = NOTE_KEYS[slotKey];
    return key ? t(key) : null;
}
